
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ad-studio/insights",
      function () {
        return require("private-next-pages/ad-studio/insights.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ad-studio/insights"])
      });
    }
  